// Dates that survive hydration.
//
// Every page here is rendered once on the server by Node and again in the
// visitor's browser, and the two strings have to match byte for byte or React
// throws the server-rendered page away (#418). Two things break that, and this
// app has now been bitten by both:
//
//  - The timezone. Fixed at the call sites by pinning `timeZone: "UTC"`, and in
//    utils/tenure.ts, which is the same bug on the resume.
//  - The locale data, which is what this file exists for. CLDR 42 changed the
//    en-GB abbreviation for September from "Sep" to "Sept". Node's ICU shipped
//    that change and WebKit has not, so gazar.dev server-rendered "7 Sept 2024"
//    on every article and every Safari, iOS Chrome and in-app WKWebView
//    hydrated "7 Sep 2024". GlitchTip issue 148: 15 events, all WebKit, none on
//    desktop Chrome or Firefox.
//
// So the month names are ours and there is no locale data anywhere in the output
// path, only arithmetic. config/cta.ts imports the same array for the London
// session labels, so there is one list to be wrong rather than two.

export const MONTHS_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
] as const;

/**
 * A UTC instant as "7 Sep 2024", the form articles and article lists render.
 *
 * Empty string for a missing or unparseable value, because "Invalid Date" is not
 * something a reader should ever see under a headline.
 */
export function formatUtcShortDate(value: string | number | Date | null | undefined): string {
  if (value == null || value === "") return "";
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getUTCDate()} ${MONTHS_SHORT[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}
